import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

class SearchTitle extends Component {
  render() {
    const heading = _.template(this.props.translations.searchFoundResults);

    return <div className="row">
        <div className="col text-center">
          <h1 className="h2 underline underline--center--blue search-page__title">
            {heading({
              count: this.props.results.total,
              query: this.props.query,
            })}
          </h1>
        </div>
      </div>;
  }
}

function mapStateToProps(state) {
  return {
    translations: state.translations,
    query: state.query,
    results: state.searchResults,
  };
}

export default connect(mapStateToProps)(SearchTitle);
